export default "__VITE_ASSET__DkCvVp3F__"